<div class="improved-warning" 
     [class.clickable]="isClickable"
     (click)="onWarningClick()">
  <ion-icon [name]="icon" class="warning-icon" [ngStyle]="{ color: color }"></ion-icon>
  <span class="warning-message">{{ message }}</span>
</div>
